import { WizBasePopUp, WizDatasource, WizList } from '@wizeoo/akm-component-lib';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
} from '@angular/core';
import { IFreedataWidget } from '../../../../manager/widgets/i-widget';
import { FreedataValueVO } from  '../../../../vo/core/freedatavalue.vo';
import { PivotDeleteFieldRenderer } from '../../pivot/renderers/cells/pivot-delete-field.renderer';


export interface DeleteFreedataValueParams {
  fdv: FreedataValueVO,
  widget: IFreedataWidget,
  callback: Function,
}


@Component({
  // popUp d'édition des cellules de grid
  selector: 'freedata-grid-delete-pop',
  templateUrl: './freedata-grid-delete.pop.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FreedataGridDeletePop extends WizBasePopUp implements AfterViewInit {
  @ViewChild('fieldList') fieldList: WizList; // accesseur sur la liste des champs

  public fieldRenderer: any = PivotDeleteFieldRenderer; // rendu de la liste

  /** la DS de la liste */
  public mainDS: WizDatasource<[string, string]> = new WizDatasource<[string, string]>().build();

  public confirmDelete: boolean = false;

  public get params(): DeleteFreedataValueParams {
    return this.datas;
  }

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  ngAfterViewInit(): void {
    // this.callback = this.datas[0].callback;
    setTimeout(() => {
      // on attend que tout soit prêt...
      this.feedDatasources();
    }, 0);
  }

  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feedDatasources(): void {
    this.confirmDelete = false;
    const src: [string, string][] = [];
    for (let k of Object.keys(this.params.fdv.argsObjVO)) {
      src.push([k, this.params.fdv.argsObjVO[k]]);
    }
    this.mainDS.setSource(src);
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.hide();
  }

  public onHide() {
    if(!!this.confirmDelete) {
      this.params.callback([this.params.fdv]);
    }
  }

  /** confirmation de la suppression : on contrôle la présence d'un step lié */
  public doDelete(): void {
    this.confirmDelete = true;
    this.hide();
  }
}
